import { render, staticRenderFns } from "./OtpChallenge.vue?vue&type=template&id=aba003a8"
import script from "./OtpChallenge.vue?vue&type=script&lang=ts"
export * from "./OtpChallenge.vue?vue&type=script&lang=ts"
import style0 from "./OtpChallenge.vue?vue&type=style&index=0&id=aba003a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports